import React, { useContext, useState } from "react";
import Modal from "../ModalWithFooter";
import FooterModelButton from "../../buttons/FooterModelButton";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context/AuthContext";
import { makeApiRequest, showApiErrorMessages } from "../../../helpers";
import { tutorCancelSession } from "../../../api/endpoints/tutors/sessions";
import { studentCancelSession } from "../../../api/endpoints/students/sessions";
import { ApiResponse } from "../../../api/apiResponse";
import { useNavigate } from "react-router";
import CalendarScheduleCandidate from "../../../api/models/CalendarScheduleCandidate";
import CancelStudentModal from "../CancelStudentModal";
import { ToastContext } from "../../../App";
type AddCandidateModalProps = {
  isOpen: boolean;
  setIsOpen: () => void;
  session: any;
};
export const CancelSessionRequest = (props: AddCandidateModalProps) => {
  const { isOpen, setIsOpen, session } = props;
  const LocalBasePath = "page.student.dashboard.sessionInfo";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { currentUser, userType }: any = useAuth();
  const [openEmail, setOpenEmail] = useState<boolean>(false);
  const navigate = useNavigate();
  const [reasons, setReasons] = useState<string>("");
  const toast = useContext(ToastContext);

  const cancelSession = async () => {
    if (!reasons && reasons.trim() === "" && reasons?.replace(" ", "") === "") {
      toast?.error(t("notValidInput"));
      return;
    }
    const slot = new CalendarScheduleCandidate(session);
    await makeApiRequest(
      () => {
        if (userType === "tutor")
          return tutorCancelSession({
            ...slot,
            student_id: session?.student?.id,
            cancellation_reason: reasons,
            date: !!slot.date && slot.date.format("YYYY-MM-DD"),
          });
        return studentCancelSession({
          ...slot,
          cancellation_reason: reasons,
          tutor_id: session?.student?.id,
          date: !!slot.date && slot.date.format("YYYY-MM-DD"),
        });
      },
      (response: ApiResponse) => {
        if (response.isSuccess) {
          setOpenEmail(true);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };
  return (
    <>
      <Modal open={isOpen && !openEmail} setOpen={setIsOpen}>
        <Modal.Body setOpen={setIsOpen} title={t("requestCancelSession")}>
          <div>
            <label
              htmlFor="comment"
              className="block text-sm font-medium text-gray-700"
            >
              {t("cancelReason")}
            </label>
            <div className="mt-2">
              <textarea
                rows={4}
                name="comment"
                id="comment"
                className="block w-full px-3 py-2 rounded-md border-gray-300 shadow-sm focus:border-brandblue-500 focus:ring-brandblue-500 text-gray-600 sm:text-sm"
                defaultValue={""}
                onChange={(e) => setReasons(e.target.value)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <>
            <FooterModelButton
              type="submit"
              setActionStatus={() => {}}
              viewType={""}
              classStyle="relative rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
              creatingCandidateStatus={false}
              changeValue={() => {
                setIsOpen();
              }}
            >
              {t("cancel")}
            </FooterModelButton>
            <FooterModelButton
              type="submit"
              setActionStatus={() => {}}
              onClick={() => cancelSession()}
              viewType={""}
              creatingCandidateStatus={false}
              classStyle="relative mx-4 inline-flex justify-center rounded-md border border-transparent bg-brandblue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
            >
              {t("send")}
            </FooterModelButton>
          </>
        </Modal.Footer>
      </Modal>

      <CancelStudentModal
        btnText={"requestPreview"}
        isOpen={openEmail}
        closeModal={() => {
          setIsOpen();
          setOpenEmail(false);
        }}
        onPreviewClick={() => {
          setIsOpen();
          setOpenEmail(false);
          navigate(`/${userType}/dashboard/requests`);
        }}
      />
    </>
  );
};
